import * as HLF from "html-living-framework";
import { texture } from "../core/AssetHelpers";
import {BaseButton, HoverableButton, TextureButton} from "../core/Button";
import { Container } from "../core/Container";
import {Callback, Mix} from "../core/Reflection";
import { ISignal, Signal } from "../core/Signal";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import * as PlanterGameModel from "../data/PlanterGameModel";
import {TrashType} from "../data/TrashType";
import { Button } from "./Button";
import { Draggable, IDraggable, InteractionEvent, InteractionListener } from "./Draggable";
import { SplashPlayButton } from "./SplashPlayButton";

export class PlantButton extends  Mix(Button, Draggable) implements IDraggable {
    public readonly bg = this.addChild(new Sprite("btnback", {x: 0.5, y: 0.5}));
    public readonly bgOn = this.addChild(new Sprite("btnbackSelect", {x: 0.5, y: 0.5}));
    public readonly icon = this.addChild(new Sprite());
    public readonly check = this.addChild(new Sprite());

    public readonly nameVO: string;
    public readonly seedVO: string;
    public readonly plantName: string;

    public readonly onStartDrag: ISignal<InteractionListener> = Signal<InteractionListener>();
    public readonly onQuickClick: ISignal<InteractionListener> = Signal<InteractionListener>();

    protected _subscriptions: any[] = [];

    constructor(pPlantName: string, pNameVO: string, pSeedVO: string) {
        super();
        this.plantName = pPlantName;
        this.clickSfx = "buttonclick";

        this.onStartDrag.add((e: InteractionEvent, context?: any) => {
            this.onPointerUp(e!);
        });

        this.onClick.add((b, val) => {
            PubSub.publishSync("button clicked", this);
        });

        this.onOver.add(() => {
            this.bgOn.visible = true;
        });

        this.onOut.add(() => {
            this.bgOn.visible = false;
        });

        this.bg.visible = true;
        this.check.visible = false;
        this.bgOn.visible = false;

        this.nameVO = pNameVO;
        this.seedVO = pSeedVO;
        this.hoverVO = this.seedVO;

        this.interactive = true;

        this.icon.setLayoutTexture("ui-" + pPlantName, 0.5, 0.5);

        this.name = pPlantName;

        this.check.alpha = 0; // temp?
    }

    public destroy() {
        super.destroy();
        for (const subscription of this._subscriptions) {
            PubSub.unsubscribe(subscription);
        }
    }

    public pulse() {
        super.pulse();
        this.bgOn.visible = true;
    }

    public stopPulse() {
        super.stopPulse();
        this.bgOn.visible = false;
    }
}
